import styled from 'styled-components';

export const Lead = styled.p`
  font-size: 16px;
  line-height: 24px;
`;
